import _asyncToGenerator from "D:/workBag/projectDemo/vuedemo10/xmmanagement/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5f37a457"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "div-body"
};
var _hoisted_2 = {
  style: {
    "border": "1px solid #ccc"
  }
};
var _hoisted_3 = {
  class: "footerSub"
};
import "@wangeditor/editor/dist/css/style.css"; // 引入 css

import { onBeforeUnmount, ref, shallowRef, onMounted, reactive, toRefs, nextTick, getCurrentInstance, unref } from "vue";
import { addFAQ, getFAQById, updateFAQ } from "@/api/xmManagement/lindo/lindoFAQ";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { ElMessage } from "element-plus/lib/components";
import { client } from "@/utils/oss";
import router from "../../router";
import { useRoute } from "vue-router";
import { getPlatform } from "@/api/xmManagement/production/platform";
export default {
  __name: 'problemedit',
  setup: function setup(__props) {
    var route = useRoute();

    components: {
      // eslint-disable-next-line no-unused-expressions
      Editor, Toolbar;
    } // 编辑器实例，必须用 shallowRef


    var _getCurrentInstance = getCurrentInstance(),
        proxy = _getCurrentInstance.proxy;

    var editorRef = shallowRef();
    var bodyData = ref("");
    var markdownToHtml = ref("");
    var company = ref();
    var data = reactive({
      formData: {
        language: undefined,
        id: undefined,
        message: undefined,
        model: undefined,
        title: undefined,
        status: 0,
        type: undefined,
        tag: undefined
      },
      jsonPhxList: [{
        name: "注册",
        value: "注册"
      }, {
        name: "连接",
        value: "连接"
      }, {
        name: "安装",
        value: "安装"
      }, {
        name: "功能",
        value: "功能"
      }, {
        name: "服务",
        value: "服务"
      }, {
        name: "配件",
        value: "配件"
      }],
      classifyList: [{
        name: "Featured",
        value: "Featured"
      }, {
        name: "Before you buy",
        value: "Before you buy"
      }, {
        name: "Installtion",
        value: "Installtion"
      }, {
        name: "Setting",
        value: "Setting"
      }, {
        name: "Troubleshotting",
        value: "Troubleshotting"
      }, {
        name: "Lindo Life APP",
        value: "Lindo Life APP"
      }, {
        name: "User Manual",
        value: "User Manual"
      }],
      productList: [{
        name: "LS101",
        value: "LS101"
      }, {
        name: "LSC",
        value: "LSC"
      }, {
        name: "LSC02",
        value: "LSC02"
      }, {
        name: "LSC11",
        value: "LSC11"
      }],
      checkList: [{
        checked: false,
        name: "Record"
      }, {
        checked: false,
        name: "Motion"
      }, {
        checked: false,
        name: "Battery"
      }, {
        checked: false,
        name: "APP"
      }, {
        checked: false,
        name: "Notifcation"
      }, {
        checked: false,
        name: "Installation"
      }, {
        checked: false,
        name: "Network"
      }],
      langList: [{
        name: "中文",
        value: "zh"
      }, {
        name: "英文",
        value: "en"
      }]
    });

    var _toRefs = toRefs(data),
        formData = _toRefs.formData,
        classifyList = _toRefs.classifyList,
        langList = _toRefs.langList,
        jsonPhxList = _toRefs.jsonPhxList,
        productList = _toRefs.productList,
        checkList = _toRefs.checkList;

    var platforms = ref({
      platformList: []
    }); // 获取产品id列表

    var selectPlatForms = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPlatform();

              case 2:
                platforms.value = _context.sent;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function selectPlatForms() {
        return _ref.apply(this, arguments);
      };
    }(); // 内容 HTML


    var rules = ref({
      title: [{
        required: true,
        message: "请输入问题名称",
        trigger: "blur"
      }],
      // type: [
      //   {
      //     required: true,
      //     message: '请选择问题类别',
      //     trigger: 'change'
      //   }
      // ],
      // model: [
      //   {
      //     required: true,
      //     message: '请选择产品分类',
      //     trigger: 'change'
      //   }
      // ],
      message: [{
        required: true,
        message: "产品内容不能为空",
        trigger: "blur"
      }]
    });

    var getFAQByIds = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item) {
        var ret;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getFAQById(item);

              case 2:
                ret = _context2.sent;
                data.formData.id = ret.id;
                data.formData.language = ret.language || undefined;
                data.formData.message = ret.message;
                data.formData.model = ret.model;
                data.formData.title = ret.title;
                data.formData.type = ret.type;

                if (ret.tag) {
                  data.formData.tag = ret.tag;
                  data.formData.tag.forEach(function (item) {
                    checkList.value.forEach(function (items) {
                      if (items.name === item) {
                        items.checked = true;
                      }
                    });
                  });
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getFAQByIds(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var _onChange = function onChange(item, index) {
      checkList.value[index].checked = item;
    };

    onMounted(function () {
      selectPlatForms();
      reset();
      nextTick(function () {
        if (route.query.id) {
          // route.meta.title = '问题修改'
          getFAQByIds(route.query);
        } else {// route.meta.title = '问题添加'
        }
      });
    });
    var valueHtml = ref("");

    var submit = function submit() {
      bodyData.value = valueHtml.value;
    };

    var toolbarConfig = {};
    var editorConfig = {
      MENU_CONF: {}
    };
    editorConfig.MENU_CONF["uploadImage"] = {
      // 自定义上传
      customUpload: function customUpload(file, insertFn) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var fileSize, fileSuffix, whiteList;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  fileSize = file.size < 1024 * 1024;
                  fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
                  whiteList = ["jpg", "png", "bmp"];

                  if (!(whiteList.indexOf(fileSuffix) === -1)) {
                    _context3.next = 6;
                    break;
                  }

                  ElMessage.error("上传图片必须为.jpg .png .bmp类型！");
                  return _context3.abrupt("return", false);

                case 6:
                  if (fileSize) {
                    _context3.next = 11;
                    break;
                  }

                  ElMessage.error("上传图片大小不能超过1M！");
                  return _context3.abrupt("return", false);

                case 11:
                  client.put("FAQ" + "/" + new Date().getTime() + file.name, file).then(function (res) {
                    if (res.res.statusCode === 200) {
                      insertFn(res.url);
                    } else {
                      ElMessage.error("上传失败");
                    }
                  });

                case 12:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      } // 小于该值就插入 base64 格式（而不上传），默认为 0
      //   base64LimitSize: 1024 * 1024 // 1mb

    };
    editorConfig.MENU_CONF["color"] = {
      colors: ["rgb(29,29,31)", "rgb(89, 89, 89)", "rgb(140, 140, 140)", "rgb(191, 191, 191)", "rgb(217, 217, 217)", "rgb(233, 233, 233)", "rgb(245, 245, 245)", "rgb(250, 250, 250)", "rgb(255, 255, 255)", "rgb(225, 60, 57)", "rgb(231, 95, 51)", "rgb(235, 144, 58)", "rgb(245, 219, 77)", "rgb(114, 192, 64)", "rgb(89, 191, 192)", "rgb(66, 144, 247)", "rgb(54, 88, 226)", "rgb(106, 57, 201)", "rgb(216, 68, 147)", "rgb(251, 233, 230)", "rgb(252, 237, 225)", "rgb(252, 239, 212)", "rgb(252, 251, 207)", "rgb(231, 246, 213)", "rgb(218, 244, 240)", "rgb(217, 237, 250)", "rgb(224, 232, 250)", "rgb(237, 225, 248)", "rgb(246, 226, 234)", "rgb(255, 163, 158)", "rgb(255, 187, 150)", "rgb(255, 213, 145)", "rgb(255, 251, 143)", "rgb(183, 235, 143)", "rgb(135, 232, 222)", "rgb(145, 213, 255)", "rgb(173, 198, 255)", "rgb(211, 173, 247)", "rgb(255, 173, 210)", "rgb(255, 77, 79)", "rgb(255, 122, 69)", "rgb(255, 169, 64)", "rgb(255, 236, 61)", "rgb(115, 209, 61)", "rgb(54, 207, 201)", "rgb(64, 169, 255)", "rgb(89, 126, 247)", "rgb(146, 84, 222)", "rgb(247, 89, 171)", "rgb(207, 19, 34)", "rgb(212, 56, 13)", "rgb(212, 107, 8)", "rgb(212, 177, 6)", "rgb(56, 158, 13)", "rgb(8, 151, 156)", "rgb(9, 109, 217)", "rgb(29, 57, 196)", "rgb(83, 29, 171)", "rgb(196, 29, 127)", "rgb(130, 0, 20)", "rgb(135, 20, 0)", "rgb(135, 56, 0)", "rgb(97, 71, 0)", "rgb(19, 82, 0)", "rgb(0, 71, 79)", "rgb(0, 58, 140)", "rgb(6, 17, 120)", "rgb(34, 7, 94)", "rgb(120, 6, 80)"]
    };
    editorConfig.MENU_CONF["fontFamily"] = {
      fontFamilyList: [// 元素支持两种形式
      //   1. 字符串；
      //   2. { name: 'xxx', value: 'xxx' }
      "HelveticaNeueBold", "HelveticaNeueMedium", "HelveticaNeueLight", "HelveticaNeueRegular", "HelveticaNeueThin", "黑体", "仿宋", "楷体", "标楷体", "华文仿宋", "华文楷体", "宋体", "微软雅黑", "Arial", "Tahoma", "Verdana"]
    }; // 模拟 ajax 异步获取内容
    // 组件销毁时，也及时销毁编辑器

    onBeforeUnmount(function () {
      var editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    }); // 粘贴事件对象

    var customPaste = function customPaste(editor, event, callback) {
      console.log("ClipboardEvent 粘贴事件对象", event); // 自定义插入内容
      // editor.insertText('xxx');
      // 返回值（注意，vue 事件的返回值，不能用 return）
      // event.preventDefault()

      callback(true); // 返回 false ，阻止默认粘贴行为
      // callback(true) // 返回 true ，继续默认的粘贴行为
    };

    var handleCreated = function handleCreated(editor) {
      editorRef.value = editor; // 记录 editor 实例，重要！
    };

    var reset = function reset() {
      proxy.resetForm("formRef");
      checkList.value.forEach(function (item) {
        item.checked = false;
      });
    };

    var openGo = function openGo() {
      router.go(-1);
    }; // 表单提交


    var formRef = ref();

    var submitIssue = function submitIssue() {
      var forms = unref(formRef.value);
      if (!forms) return;
      forms.validate( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(valid) {
          var dataList;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (valid) {
                    dataList = [];
                    checkList.value.forEach(function (item) {
                      if (item.checked) {
                        dataList.push(item.name);
                      }

                      return dataList;
                    });
                    data.formData.tag = dataList;

                    if (data.formData.id) {
                      updateFAQ(data.formData).then(function () {
                        ElMessage.success("修改成功");
                        reset();
                        openGo();
                      });
                    } else {
                      addFAQ(data.formData).then(function () {
                        ElMessage.success("添加成功");
                        reset();
                        openGo();
                      });
                    }
                  }

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    };

    onMounted(function () {
      company.value = localStorage.getItem("company");
    });
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_check_tag = _resolveComponent("el-check-tag");

      var _component_el_form = _resolveComponent("el-form");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_card = _resolveComponent("el-card");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "box-card",
        style: {
          "height": "100%",
          "overflow": "auto"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: _unref(formData),
            rules: rules.value,
            "label-position": "right",
            "label-width": "100px"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                label: "问题名称",
                prop: "title"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: _unref(formData).title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(formData).title = $event;
                    }),
                    placeholder: "请输入问题名称",
                    clearable: ""
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "语言"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _unref(formData).language,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _unref(formData).language = $event;
                    })
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langList), function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.name,
                          value: item.value
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "产品分类",
                prop: "model"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _unref(formData).model,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return _unref(formData).model = $event;
                    }),
                    multiple: "",
                    placeholder: "请选择产品分类"
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platforms.value.platformList, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.productId,
                          label: item.productName,
                          value: item.productId
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "问题类别",
                prop: "type"
              }, {
                default: _withCtx(function () {
                  return [company.value === '1547256399401099264' ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 0,
                    modelValue: _unref(formData).type,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                      return _unref(formData).type = $event;
                    }),
                    placeholder: "请选择问题类别"
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classifyList), function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.name,
                          value: item.value
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_select, {
                    key: 1,
                    modelValue: _unref(formData).type,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                      return _unref(formData).type = $event;
                    }),
                    placeholder: "请选择问题类别"
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jsonPhxList), function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.name,
                          value: item.value
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue"]))];
                }),
                _: 1
              }), company.value === '1547256399401099264' ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "问题标签",
                prop: "type"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkList), function (item, index) {
                    return _openBlock(), _createBlock(_component_el_check_tag, {
                      style: {
                        "margin-right": "15px"
                      },
                      key: index,
                      checked: item.checked,
                      onChange: function onChange($event) {
                        return _onChange($event, index);
                      }
                    }, {
                      default: _withCtx(function () {
                        return [_createTextVNode(_toDisplayString(item.name), 1)];
                      }),
                      _: 2
                    }, 1032, ["checked", "onChange"]);
                  }), 128))])];
                }),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
                label: "问题详情",
                prop: "message"
              }, {
                default: _withCtx(function () {
                  return [_withDirectives(_createVNode(_component_el_input, {
                    modelValue: _unref(formData).message,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                      return _unref(formData).message = $event;
                    })
                  }, null, 8, ["modelValue"]), [[_vShow, false]]), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(Toolbar), {
                    style: {
                      "border-bottom": "1px solid #ccc"
                    },
                    editor: _unref(editorRef),
                    defaultConfig: toolbarConfig,
                    mode: _ctx.mode
                  }, null, 8, ["editor", "mode"]), _createVNode(_unref(Editor), {
                    style: {
                      "height": "500px",
                      "overflow-y": "hidden"
                    },
                    modelValue: _unref(formData).message,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                      return _unref(formData).message = $event;
                    }),
                    defaultConfig: editorConfig,
                    mode: _ctx.mode,
                    onOnCreated: handleCreated,
                    onCustomPaste: customPaste
                  }, null, 8, ["modelValue", "mode"])])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: submitIssue
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("确认提交")];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: openGo
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("返回上一页")];
            }),
            _: 1
          })])];
        }),
        _: 1
      })]);
    };
  }
};